import React, { useState, useEffect } from 'react';
import { Stack } from 'react-bootstrap';
import { Button, Icon } from 'lb-components';
import { Api, Toast, useTranslation } from 'lb-store';
import { UseRegister, UseAlert, UseVerification } from 'lb-store/src/hooks';
import {
  InstructionsIcon,
  PlusIcon,
  RewardIcon,
  InfoIconFill,
  SuccessIconFill,
} from '../../../../assets/icons';
import _ from 'lodash';
import classNames from 'classnames';
import info from './info';

import classes from './InviteFriend.module.scss';

//verification steps: 1-available, 2-pending, 3-approved, 4-denied
const verificationErrors = {
  invalid_doc_values: {
    label: 'განახლება',
    info: 'მითითებული მონაცემები არასწორია, გთხოვთ სცადოთ თავიდან.',
  },
  invalid_pid: {
    label: 'განახლება',
    info: 'მითითებული მონაცემები არასწორია, გთხოვთ სცადოთ თავიდან.',
  },
  invalid_images: {
    label: 'განახლება',
    info: 'დოკუმენტის ხარისხი არ შეესაბამება სტანდარტს, გთხოვთ სცადოთ თავიდან.',
  },
  filial: {
    label: 'უარყოფილი',
    info: 'მომხმარებელმა ვერ გაიარა Online ვერფიკაცია. ვერიფიკაციის გასავლელად გთხოვთ მიმართოთ Leader-bet-ის ნებისმიერ ფილიალს.',
  },
};

const InviteFriend = () => {
  const [list, setList] = useState();
  const [progress, setProgress] = useState();
  const registerModal = UseRegister();
  const alertModal = UseAlert();
  const verificationModal = UseVerification();
  const { t, i18n } = useTranslation();

  const fetchData = () => {
    Api.User.Referrals().then((res) => {
      console.log(res);
      if (res.status && res.data?.status === 1) {
        setList(res.data.data.list);
        setProgress(res.data.data.progress);
      }
    });
  };
  useEffect(() => {
    fetchData();
  }, []);

  const getEntryData = (step, verify_status, referralId) => {
    switch (step) {
      case 1:
        return (
          <span
            className={classes.action}
            onClick={() => openVerification(referralId)}
          >
            {t('ვერიფიკაცია')}
          </span>
        );
      case 2:
        return <span className={classes.pending}>{t('მიმდინარე')}</span>;
      case 3:
        return (
          <Icon
            Icon={SuccessIconFill}
            type={'vec'}
            style={{
              height: '3rem',
              width: '3rem',
              backgroundColor: 'rgba(var(--bs-success-rgb, 0.6))',
              marginRight: '0.2rem',
            }}
          />
        );
      case 4:
        return (
          <>
            <div
              className={classes.tooltip}
              tabIndex={0}
              style={{ marginRight: 'auto' }}
            >
              <Icon
                tabIndex={0}
                Icon={InfoIconFill}
                type={'vec'}
                style={{
                  height: '2.2rem',
                  width: '2.2rem',
                  backgroundColor: '#d5dbab',
                  cursor: 'pointer',
                }}
                /*onClick={(e) => {
                  e.target.nextSibling.style.display = 'block';
                  setTimeout(() => {
                    e.target.nextSibling.style.display = 'none';
                  }, 2000);
                }}*/
              />
              {verify_status !== '' && (
                <span>{t(verificationErrors[verify_status]?.info)}</span>
              )}
            </div>
            {verify_status !== '' && (
              <span
                onClick={() => {
                  if (verify_status !== 'filial') openVerification(referralId);
                }}
                className={
                  verify_status === 'filial' ? classes.fail : classes.action
                }
              >
                {t(verificationErrors[verify_status].label)}
              </span>
            )}
          </>
        );
    }
  };

  const openVerification = (referralId) => {
    verificationModal.open({
      referralId,
      onSuccess: () => {
        alertModal.open({
          message: t(
            'დოკუმენტები ატვირთულია მიმდინარეობს ვერიფიკაცია ვერიფიცაკიის შესახებ შეტყობინებას მიიღებთ SMS-ით'
          ),
          onCancel: () => fetchData(),
        });
      },
    });
  };
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <h1>{t('მოიწვიე მეგობარი და მიიღე საჩუქარი')}</h1>
        <div className={classes.actions}>
          <Button
            variant={'success'}
            onClick={() => {
              registerModal.open({
                onSuccess: ({ referralId }) => {
                  alertModal.open({
                    message: t('მომხმარებელი წარმატებით დარეგისტრირდა'),
                    actionLabel: 'ვერიფიკაცია',
                    onSuccess: ({ cancel }) => {
                      openVerification(referralId);
                      cancel();
                    },
                    onCancel: () => fetchData(),
                  });
                },
                isReferral: true,
              });
            }}
          >
            <Icon
              style={{
                height: '2.3rem',
                width: '2.3rem',
                backgroundColor: '#fff',
                marginRight: '0.8rem',
              }}
              Icon={PlusIcon}
              type={'vec'}
            />
            {t('მოიწვიე')}
          </Button>
          <Button
            variant={'secondary'}
            onClick={() =>
              alertModal.open({ message: info[i18n.language], size: 'lg' })
            }
          >
            <Icon
              style={{
                height: '2.3rem',
                width: '2.3rem',
                backgroundColor: '#fff',
                marginRight: '0.8rem',
              }}
              Icon={InstructionsIcon}
              type={'vec'}
            />
            {t('ინსტრუქცია')}
          </Button>
        </div>
        <div className={classes.progress}>
          {_.map(progress, (item, index) => (
            <React.Fragment key={item.type}>
              <div className={classes.item}>
                <span
                  className={classNames(
                    classes.reward,
                    item.rewarded ? classes.done : null
                  )}
                  data-prize={item.prize}
                >
                  {item.progress}/{item.type}
                </span>
              </div>
              {index !== progress.length - 1 && (
                <div className={classes.divider} />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
      <main>
        <div className={classes.headings}>
          <span>{t('მომხმარებელი')}</span>
          <span>{t('საჩუქარი')}</span>
          <span>{t('სტატუსი')}</span>
        </div>
        <div className={classes.list}>
          {_.map(list, (entry) => (
            <div
              key={entry.referral_id}
              className={classNames({
                [classes.entry]: true,
                [classes.success]: entry.step === 3,
                [classes.error]: entry.step === 4,
              })}
            >
              <span>{entry.username}</span>
              <span style={{ display: 'flex', justifyContent: 'center' }}>
                <div className={classes.tooltip} tabIndex={0}>
                  <Icon
                    tabIndex={0}
                    Icon={RewardIcon}
                    type={'vec'}
                    style={{
                      height: '2.1rem',
                      width: '2.1rem',
                      backgroundColor: entry.rewarded ? '#fff' : '#8d8c8c',
                      cursor: 'pointer',
                    }}
                    /*onClick={(e) => {
                      e.target.nextSibling.style.display = 'block';
                      setTimeout(() => {
                        e.target.nextSibling.style.display = 'none';
                      }, 2000);
                    }}*/
                  />
                  <span style={{ width: '15rem', padding: '0.7rem' }}>
                    50 FreeSpin
                  </span>
                </div>
              </span>
              <div className={classes.actionContainer}>
                {getEntryData(
                  entry.step,
                  entry.verify_status,
                  entry.referral_id
                )}
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default InviteFriend;
